import { FormBuilder, FormGroup, Validators } from "@angular/forms";

export class M_STORE_USER_TIME {

    hQ_CD: string = '';
    stR_CD: string = '';
    useR_ID: string = '';

    day: string = '';
    day_nm: string = '';
    daY_SEQ: number | null = null;

    starT_TIME: Date | null = null;
    enD_TIME: Date | null = null;

    remark: string | null = null;
    usE_YN: string | null = null;

    inserT_DT: Date | null = null;
    inserT_USER: string | null = null;
    updatE_DT: Date | null = null;
    updatE_USER: string | null = null;

    constructor(init?: Partial<M_STORE_USER_TIME>) {
        Object.assign(this, init);
    }

    // ===============================
    // JSON -> Model
    // ===============================

    fromJSON(json: any): M_STORE_USER_TIME {
        return new M_STORE_USER_TIME(json);
    }

    getSchedule(res: any): M_STORE_USER_TIME | null {
        if (!res) return null;
        return this.mapSchedule(res);
    }

    getAllSchedules(res: any[]): M_STORE_USER_TIME[] {
        return (res ?? []).map(item => this.mapSchedule(item));
    }

    private mapSchedule(item: any): M_STORE_USER_TIME {

        if (item.starT_TIME) {
            item.starT_TIME = this.formatTime(item.starT_TIME);
        }

        if (item.enD_TIME) {
            item.enD_TIME = this.formatTime(item.enD_TIME);
        }

        if (item.inserT_DT) {
            item.inserT_DT = new Date(item.inserT_DT);
        }

        if (item.updatE_DT) {
            item.updatE_DT = new Date(item.updatE_DT);
        }

        return new M_STORE_USER_TIME(item);
    }

    // ===============================
    // Model -> JSON (call API)
    // ===============================

    toJSON(): any {
        const obj: any = {};

        Object.keys(this).forEach(key => {
            const value = (this as any)[key];

            if ((key === 'starT_TIME' || key === 'enD_TIME') && value) {
                obj[key] = this.formatTimeToHHmm(value);
            }
            else {
                obj[key] = value ?? null;
            }
        });

        return obj;
    }

    // ===============================
    // Form
    // ===============================

    createForm(fb: FormBuilder): FormGroup {
        return fb.group({
            hQ_CD: [this.hQ_CD],
            stR_CD: [this.stR_CD],
            useR_ID: [this.useR_ID],

            day: [this.day, Validators.required],
            day_nm: [this.day_nm],
            daY_SEQ: [this.daY_SEQ],

            starT_TIME: [this.starT_TIME, Validators.required],
            enD_TIME: [this.enD_TIME, Validators.required],

            remark: [this.remark],
            usE_YN: [this.usE_YN]
        });
    }

    // ===============================
    // Utils
    // ===============================

    private formatTime(num: string): Date | null {
        if (!num) return null;

        const time = num.padStart(4, '0');

        const hour = Number(time.substring(0, 2));
        const minute = Number(time.substring(2, 4));

        const now = new Date();
        now.setHours(hour, minute, 0, 0);

        return now;
    }

    private formatTimeToHHmm(date: Date): string {
        const hh = String(date.getHours()).padStart(2, '0');
        const mm = String(date.getMinutes()).padStart(2, '0');
        return `${hh}${mm}`;
    }
}